export const FETCH_EMP_DISCRIPENCY_REQUEST = "FETCH_EMP_DISCRIPENCY_REQUEST";
export const FETCH_EMP_DISCRIPENCY_SUCCESS = "FETCH_EMP_DISCRIPENCY_SUCCESS";
export const FETCH_EMP_DISCRIPENCY_FAILURE = "FETCH_EMP_DISCRIPENCY_FAILURE";



